import { Component, HostListener, OnInit } from '@angular/core';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { DuprService } from '../dupr.service';
import { LocalStorage } from '@core/localstorage';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-dupr-modal',
    templateUrl: './dupr-modal.component.html',
    styleUrls: ['./dupr-modal.component.scss'],
})
export class DuprModalComponent implements OnInit {
    loading: boolean = false;
    urlDupr: string = '';

    redirectRoute: string;

    constructor(
        private dialogRef: NbDialogRef<DuprModalComponent>,
        private DUPRService: DuprService,
        private localStorage: LocalStorage,
        private nbToastrService: NbToastrService
    ) { }

    ngOnInit(): void {
        this.urlDupr = `${environment.urlDupr}login-external-app/${btoa(environment.clientKeyDupr)}`;
    }

    @HostListener('window:message', ['$event'])
    onExternalLoginMessage(event: MessageEvent) {
        const payload: any = event.data || {};
        const { duprId, id, stats } = payload;

        if (duprId) {
            const currentUser = this.localStorage.getUser();

            const userId = currentUser.id_site;

            this.localStorage.saveUser({ ...currentUser, dupr_external_id: duprId })

            this.DUPRService.syncPlayerData(userId, duprId, id, [
                {
                    type: 'SINGLES',
                    points: stats?.singles == 'NR' ? 0 : Number(stats?.singles) || 0,
                    confidence_level: stats?.singlesVerified == 'NR' ? 0 : Number(stats?.singlesVerified) || 0,
                },
                {
                    type: 'DOUBLES',
                    points: stats?.doubles == 'NR' ? 0 : Number(stats?.doubles) || 0,
                    confidence_level: stats?.doublesVerified == 'NR' ? 0 : Number(stats?.doublesVerified) || 0,
                }
            ]).subscribe(() => {
                this.close();
                this.nbToastrService.success('Dados DUPR sincronizados com sucesso!', 'Sucesso');
                window.dispatchEvent(new Event('duprSyncComplete', { bubbles: true }));
            }, (error) => {
                console.log('error', error);
                this.nbToastrService.danger('Erro ao sincronizar dados DUPR. Tente novamente mais tarde.', 'Erro');
            });
        }
    }

    close(): void {
        this.dialogRef.close();
    }
}
